import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SsiUplineProfileProps } from "../services/StrongStart/ssiAPI.types";
import { SSIUplineResponse } from "../services/SSIUpline/ssiUplineAPI.types";
import { setBoot } from "./boot";
export enum ssiUplineReportTabs {
  GRACE_PERIOD_TAB = "grace_period_tab",
  IN_SSI_PROGRAM_TAB = "in_ssi_program_tab",
  EARNED_PAYMENT_TAB = "earned_payment_tab",
  OUT_SSI_PROGRAM_TAB = "out_ssi_program_tab",
}

const defaultSSIUplineData = (): SSIUplineResponse => ({
  PreWindow: {
    Periods: [],
  },
  InWindow: {
    InPaymentMonth: [],
    InSSIProgram: [],
  },
  OutOfProgram: {
    ABOs: [],
  },
  EarnedPayment: {
    Groups: [],
  },
  CallResults: [],
  Error: [],
});

interface SSIUplineState {
  defaultView: ssiUplineReportTabs;
  activeView: ssiUplineReportTabs;
  activeTabs: ssiUplineReportTabs[];
  ssiUplineData: SSIUplineResponse;
  isLoading: boolean;
  errorStatus: boolean;
  ssiUplineProfileProps: SsiUplineProfileProps;
}

export const initialState: SSIUplineState = {
  defaultView: ssiUplineReportTabs.GRACE_PERIOD_TAB,
  activeView: ssiUplineReportTabs.GRACE_PERIOD_TAB,
  activeTabs: [
    ssiUplineReportTabs.GRACE_PERIOD_TAB,
    ssiUplineReportTabs.IN_SSI_PROGRAM_TAB,
    ssiUplineReportTabs.EARNED_PAYMENT_TAB,
    ssiUplineReportTabs.OUT_SSI_PROGRAM_TAB,
  ],
  ssiUplineData: defaultSSIUplineData(),
  isLoading: false,
  errorStatus: false,
  ssiUplineProfileProps: {
    aboNo: "",
    affNo: "",
    sponsorNo: "",
    sponsorAff: "",
    eligibilityWindow: {
      EntryPeriod: "",
      StartPeriod: "",
      EndPeriod: "",
      CurrentYear: [
        {
          Period: 0,
          BadgeType: "",
        },
      ],
      NextYear: [
        {
          Period: 0,
          BadgeType: "",
        },
      ],
      PayDayMonths: [3, 6, 12],
      MarketHasGracePeriod: false,
    },
    showEligibilityWindow: false,
    show: false,
    previousElementID: "",
  },
};

const { actions, reducer } = createSlice({
  name: "ssiUplineReport",
  initialState,
  reducers: {
    setActiveTabView: (state, action: PayloadAction<ssiUplineReportTabs>) => {
      const { payload } = action;
      return {
        ...state,
        activeView: payload,
      };
    },
    setSSIUplineData: (state, action: PayloadAction<SSIUplineResponse>) => {
      state.ssiUplineData = action.payload;
    },
    setSSIUplineLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setSSIUplineErrorStatus: (state, action: PayloadAction<boolean>) => {
      state.errorStatus = action.payload;
    },
    openProfileModal: (state, action: PayloadAction<SsiUplineProfileProps>) => {
      const { payload } = action;
      return {
        ...state,
        ssiUplineProfileProps: payload,
      };
    },
    closeProfileModal: (state) => {
      return {
        ...state,
        ssiUplineProfileProps: initialState.ssiUplineProfileProps,
      };
    },
    setAboSearchResult: (state, searchResultObj: PayloadAction<any>) => {
      return {
        ...state,
        aboSearchResult: searchResultObj,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(setBoot, (state, { payload }) => {
      const { ssiUplineReport } = payload.configuration || {};
      return {
        ...state,
        activeTabs:
          ssiUplineReport?.availableTabs && ssiUplineReport?.availableTabs.length > 0
            ? ssiUplineReport.availableTabs
            : state.activeTabs,
      };
    });
  },
});

export const {
  setActiveTabView,
  setSSIUplineData,
  setSSIUplineLoading,
  setSSIUplineErrorStatus,
  openProfileModal,
  closeProfileModal,
  setAboSearchResult,
} = actions;

export default reducer;
